import React from 'react';

const Glossary = () => {
  return (
    <div className="row">
      <div className="col-xs-12 glossary-container">
        <div className="glossary-header">Glossary:</div>
        <ul>
          <li>
            Valuation includes the cash from the most recent investment, unless otherwise noted.
          </li>
          <li>
            Annual recurring revenue refers to customer commitments to buy a startup’s product over
            the next 12 months.
          </li>
          <li>Annualized revenue refers to the last month’s revenue multiplied by 12.</li>
        </ul>
      </div>
    </div>
  );
};

export default Glossary;
